const SHIPSY_REMARK = 'Shipsy-inventory-adjustment'
const SHIPSY_ZONE_MOVEMENT_REMARK = 'Shipsy-zone-movement'

const SHIPSY_SOURCE = 'shipsy'

const STOCK_TRANSACTION_TYPES = {
  ZONE_MOVEMENT: 'zone_movement',
  ADJUSTMENT: 'adjustment',
  GRN: 'grn',
  RTV: 'rtv',
  SALES_RETURN: 'sales_return',
  INVOICE: 'invoice'
}

// Zone categories reported by Shipsy.
const ZONE_CATEGORIES = {
  BULK_STORAGE: 'sellable',
  COLD_STORAGE: 'sellable',
  CONTROLLED_DRUGS_STORAGE: 'sellable',
  DEFAULT: 'sellable',
  NEAR_EXPIRY: 'sellable',
  QUALITY_CHECK: 'sellable',
  TESTZONE: 'sellable',
  UNIT_STORAGE: 'sellable',
  DAMAGED_STORAGE: 'non_sellable',
  EXPIRY_STORAGE: 'non_sellable',
  NTE_STORAGE: 'non_sellable',
  RESERVED_STORAGE: 'non_sellable',
  RETURN_STORAGE: 'non_sellable',
  SHORT_ZONE: 'non_sellable',
  TRANSIT_ZONE: 'non_sellable',
  WIPZONE: 'non_sellable'
}

const NON_SELLABLE_ZONES = Object.keys(ZONE_CATEGORIES)
  .filter(zone => ZONE_CATEGORIES[zone] === 'non_sellable')

module.exports = {
  SHIPSY_REMARK,
  SHIPSY_ZONE_MOVEMENT_REMARK,
  SHIPSY_SOURCE,
  STOCK_TRANSACTION_TYPES,
  ZONE_CATEGORIES,
  NON_SELLABLE_ZONES
}
